import classnamesBind from "classnames/bind";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { useTranslatedText } from "./useTranslatedText";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import styles from "./ReleaseDateBanner.scss";
import showEarlyAccessBanner from "../../../common/showEarlyAccessBanner/showEarlyAccessBanner";

const classnames = classnamesBind.bind(styles);

const ReleaseDateBanner = ({ className }) => {
  const { getTranslation, product, isMixAndMatch } = useRuntimeConstants();
  const { customerAccess, endDate } = getCustomerLoyaltyAccess(
    product,
    isMixAndMatch,
  );

  const textToRender = useTranslatedText(
    getTranslation,
    customerAccess,
    endDate,
  );

  if (!showEarlyAccessBanner(product, isMixAndMatch) || !textToRender) {
    return null;
  }

  const accessClass = customerAccess && `access-${customerAccess}`;

  return (
    <div
      className={classnames(
        styles.releaseDateBanner,
        styles[accessClass],
        className,
      )}
    >
      {textToRender}
    </div>
  );
};

export default ReleaseDateBanner;
